import { SetPwForm } from '../components/forms/set-pw-form';
import { Container } from '../components/layout/container';
import Layout from '../components/layout/layout';

const ConfirmEmailPage = () => (
  <Layout canonicalUrl='/profile'>
    <Container>
      <SetPwForm className='mt-10' />
    </Container>
  </Layout>
);

export default ConfirmEmailPage;
